<template>
  <div class="w-full flex flex-col gap-2 py-4">
    <div
      class="flex flex-row items-center justify-center gap-2 text-lg font-bold"
    >
      <IconComponent icon="check" class="text-success-darker" />
      <span>{{ person.winCount || 0 }} {{ $t("statCard.won") }}</span>
    </div>
    <div
      class="flex flex-row items-center justify-center gap-2 text-lg font-bold"
    >
      <IconComponent icon="star" class="text-rating" />
      <a href="#ratings">{{ scoreCount }} {{ $t("statCard.reviews") }}</a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    person: {
      type: Object,
      required: true,
    },
  },
  computed: {
    scoreCount() {
      return this.person.scores.filter((x) => !x.deleted).length;
    },
  },
};
</script>
